export var CardholdersScreen;
(function (CardholdersScreen) {
    CardholdersScreen["ACCESS_DENIED_SCREEN"] = "access_denied";
    CardholdersScreen["ADD_AUTH_USER"] = "add_auth_user";
    CardholdersScreen["ADD_AUTH_USER_SAMS"] = "add_auth_user_sams";
    CardholdersScreen["ADD_AUTH_USER_SAMS_LIST"] = "add_auth_user_sams_list";
    CardholdersScreen["CONFIRMATION_SCREEN_NEW_USER"] = "confirmation_screen_new_user";
    CardholdersScreen["CONFIRMATION_SCREEN_EXISTING_USER"] = "confirmation_screen_existing_user";
    CardholdersScreen["ERROR_SCREEN"] = "error_screen";
    CardholdersScreen["INITIAL_SCREEN"] = "initial_screen";
    CardholdersScreen["VERIFY_USER_SCREEN"] = "verify_user_screen";
    CardholdersScreen["UNSUPPORTED"] = "UNSUPPORTED";
})(CardholdersScreen || (CardholdersScreen = {}));
export var AddAuthUserInputType;
(function (AddAuthUserInputType) {
    AddAuthUserInputType["authorizedUserFirstName"] = "authorizedUserFirstName";
    AddAuthUserInputType["authorizedUserLastName"] = "authorizedUserLastName";
    AddAuthUserInputType["authorizedUserBirthDate"] = "authorizedUserBirthDate";
})(AddAuthUserInputType || (AddAuthUserInputType = {}));
export var AddAuthUserInputErrors;
(function (AddAuthUserInputErrors) {
    AddAuthUserInputErrors["authorizedUserFirstName"] = "authorizedUserFirstName";
    AddAuthUserInputErrors["authorizedUserLastName"] = "authorizedUserLastName";
    AddAuthUserInputErrors["authorizedUserBirthDate"] = "authorizedUserBirthDate";
    AddAuthUserInputErrors["authorizedUserInvalidBirthDate"] = "authorizedUserInvalidBirthDate";
    AddAuthUserInputErrors["authorizedUserFutureBirthYear"] = "authorizedUserFutureBirthYear";
    AddAuthUserInputErrors["authorizedUserPastBirthYear"] = "authorizedUserPastBirthYear";
})(AddAuthUserInputErrors || (AddAuthUserInputErrors = {}));
export var OtpErrorTypes;
(function (OtpErrorTypes) {
    OtpErrorTypes["INVALID_SCOPE"] = "invalid_scope";
    OtpErrorTypes["USER_DECLINED"] = "user_declined";
    OtpErrorTypes["ACCESS_DENIED"] = "access_denied";
    OtpErrorTypes["SERVER_ERROR"] = "server_error";
    OtpErrorTypes["UNHANDLED_ERROR"] = "Unhandled error:";
})(OtpErrorTypes || (OtpErrorTypes = {}));
export var otpErrorCallbackParamsKey = 'otpErrorCallbackParams';
